import { CalendarClock } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import SourceChip from "@/components/SourceChip";

export default function Chronology({ items }) {
  const { t } = useI18n();
  const facts = items
    .filter((i) => i.date)
    .sort((a, b) => String(a.date).localeCompare(String(b.date)));

  if (facts.length === 0) {
    return (
      <div className="rounded-xl border border-dashed border-zinc-800 p-12 text-center">
        <CalendarClock className="mx-auto h-7 w-7 text-zinc-700" strokeWidth={1.5} />
        <p className="mt-3 text-zinc-500 text-sm">
          {t("chrono.empty")}
        </p>
      </div>
    );
  }

  return (
    <div className="relative pl-6">
      <div className="absolute left-[7px] top-2 bottom-2 w-px bg-zinc-800" />
      <div className="space-y-6">
        {facts.map((f, i) => (
          <div key={f.id} className="relative animate-fade-up" style={{ animationDelay: `${i * 40}ms` }}>
            <div className="absolute -left-6 top-1.5 h-3.5 w-3.5 rounded-full border-2 border-[#d4af37] bg-[#0a0a0c]" />
            <p className="font-mono-ui text-xs text-[#d4af37]">{f.date}</p>
            <p className="mt-1 text-[15px] leading-relaxed text-zinc-200">{f.content}</p>
            <div className="mt-2"><SourceChip item={f} /></div>
          </div>
        ))}
      </div>
    </div>
  );
}
